import Icon from '../components/Icon.vue'

Icon.register({"user-circle":{"width":512,"height":512,"paths":[{"d":"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM80.5 381.9C119.7 436.4 183.7 472 256 472S392.3 436.4 431.5 381.9C428.4 354.9 408.9 332.2 382 325.5L349.6 317.4C323.6 339.8 290.7 352 256 352S188.4 339.8 162.4 317.4L130 325.5C103.1 332.2 83.6 354.9 80.5 381.9zM144 208C144 269.9 194.1 320 256 320S368 269.9 368 208 317.9 96 256 96 144 146.1 144 208z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/user-circle.js
// module id = null
// module chunks = 